<div class="content-wrapper" (click)="closeModal()">
  @if (type === ImageTypeEnum.Image || type === ImageTypeEnum.GIF) {
    <div>
      <img [src]="url" />
    </div>
  } @else {
    <div>
      <video controls autoplay playsinline>
        <source [src]="url" />
      </video>
    </div>
  }
</div>
